import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Checkbox, Divider, Form, Input, Select, Space, Tabs } from "antd"
import styled from "styled-components"
import WordManage from "./WordManage/WordManage";
import { useEffect, useState } from "react";
import axios from "axios";
import InsertWordModal from "./WordManage/InsertWordModal";
// import ImageTabRightImage from "./ImageTabRightImage";
// import ImageTabRightPrompt from "./ImageTabRightPrompt";

const backend = process.env.REACT_APP_BACKEND
const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /*width: 800px;*/
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-left: 10px;
    overflow: auto;

    & > .ant-space-item .ant-space {
      width: 100%;
    }

    & > .ant-space-item:nth-child(1) {
      text-align: left;
    }

    & > .ant-space-item:nth-child(2) {
      flex-grow: 1;
      display: flex;
      & > .ant-space {
        flex-direction: row;
      }
    }
    
  }
`

function DictionaryTabRightWordManage ({stateHandler, languageGroup, vocabularyData}) {

  const [reRender, setReRender] = useState(false)
  const [insertWordModal, setInsertWordModal] = useState(false)

  const modalHandler = () => {
    setInsertWordModal(false)
  }

  const insertWordHandler = () => {
    setInsertWordModal(true)
  }

  const reRenderHandler = () => {
    setReRender(!reRender)
  }

  const cancelHandler = () => {
    stateHandler("rightBoxWord", [false,{}])
    stateHandler("rowIndex", null)
  }

  return (
    <div>

      {insertWordModal ? <InsertWordModal stateHandlerUp={stateHandler} insertWordModal={insertWordModal} modalHandler={modalHandler} languageGroup={languageGroup} vocabularyData={vocabularyData} reRenderHandler={reRenderHandler}/> : null}

      <StyledSpace>
        <Space direction="vertical" size={0}>
          <Space size={0} style={{padding:"6px 6px 6px 10px", fontSize:"15px", fontWeight:"500"}}>단어 목록</Space>
          <Divider style={{display:"flex", margin:"0px"}}/>
        </Space>
        
        <Space direction="vertical" size={0} style={{padding: "10px"}}>
          <WordManage stateHandlerUp={stateHandler} reRender={reRender} vocabularyData={vocabularyData} languageGroup={languageGroup}/>
        </Space>

        <Space direction="vertical" size={0}>
          <Divider style={{display:"flex", margin:"0px"}}/>
          <Space size={0} style={{padding:"10px 6px 6px 6px", width:"100%", justifyContent:"space-between"}}>
            <Button onClick={insertWordHandler}>단어 추가</Button>
            <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
          </Space>
        </Space>

      </StyledSpace>
    </div>
  )
}

export default DictionaryTabRightWordManage